import React, { useContext } from 'react';
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import {
  BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid,
  Tooltip, LabelList, ResponsiveContainer } from 'recharts';

import quizInstanceStatusContext from '../context/quizInstanceStatusContext';
import QuizAdminQuestion from './QuizAdminQuestion';

export default function QuizParticipantLiveResults() {

  const ctx = useContext(quizInstanceStatusContext);
  const quizInfo = ctx.quizInfo || {};
  const liveResults = quizInfo.liveResults || {};
  const colorList = (ctx.quizStyle && ctx.quizStyle.colorList) || [];
  const primaryColors = colorList.map(c => c.primaryCss);

  const answerCountListsByQuestionId = {};
  for (const question of quizInfo.questionList || []) {
    if (!question.answerList || question.answerList.length === 0) {
      continue;
    }

    answerCountListsByQuestionId[question.id] = question.answerList.map(answer => ({
      id: answer.id,
      name: answer.text,
      count: liveResults[answer.id] || 0
    }));
  }

  return (
    <Container id="quizParticipantLiveResults">
      <Row noGutters className="justify-center">
        <Col style={{ maxWidth: "970px" }}>
          <div className="mt-4 text-center">
            <h3>Resultat hittills</h3>
          </div>

          {(quizInfo.questionList || []).map((question, qIdx) => {

            const answerCountList = answerCountListsByQuestionId[question.id];
            if (!answerCountList) {
              return null;
            }

            return (
              <div className="mt-4" key={question.id}>

                <QuizAdminQuestion
                  question={question}
                  questionNumber={qIdx + 1}
                  quizInfo={quizInfo}
                  color={colorList[qIdx % (colorList.length || 1)]}
                  showAnswers={false}
                />

                <div style={{ width: "95%", height: `${105 * answerCountList.length}px` }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                      data={answerCountList}
                      margin={{ top: 20 }}
                      layout="vertical"
                      barSize={20}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis
                        type="number"
                        allowDecimals={false}
                        orientation='top'
                        label={{
                          value: 'Antal svar',
                          fill: '#5C5D50',
                          position: "center",
                          dy: -20
                        }}
                      />
                      <YAxis
                        type="category"
                        width={30}
                        tick={false}
                      />
                      <Tooltip
                        cursor={false}
                        labelFormatter={() => ""}
                        formatter={(value) => [value, "Antal svar"]}
                      />
                      <Bar cursor="pointer" dataKey="count">
                        {answerCountList.map((entry, cellIdx) => (
                          <Cell key={`cell-${cellIdx}`} fill={primaryColors[qIdx % (primaryColors.length || 1)]} />
                        ))}

                        <LabelList
                          dataKey="name"
                          position="top"
                          content={({ x, y, value }) => {
                            const fillColor = primaryColors[qIdx % (primaryColors.length || 1)];
                            return (
                              <text
                                x={x}
                                y={y}
                                dx={10}
                                dy={-10}
                                fill={fillColor}
                                textAnchor="start"
                                className='font-weight-bold'
                              >
                                {value}
                              </text>
                            );
                          }}
                        />
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                </div>

              </div>
            );
          })}

        </Col>
      </Row>
    </Container>
  );
};
